import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["readOnlySection", "editSection", "editButton", "saveButton", "form"]

  connect() {
    // If there are validation errors, show edit mode
    if (this.hasEditSectionTarget && this.editSectionTarget.querySelector('.bg-frankly-red-50')) {
      this.showEditMode()
      this.hideReadOnlyMode()
    } else {
      this.showReadOnlyMode()
    }
    // Store original values for reset functionality
    this.storeOriginalValues()
  }

  edit() {
    this.hideReadOnlyMode()
    this.showEditMode()
  }

  cancel() {
    this.hideEditMode()
    this.showReadOnlyMode()
    this.resetForm()
  }

  save(event) {
    // Submit the form when the save button is clicked
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }

  showReadOnlyMode() {
    this.readOnlySectionTarget.classList.remove("hidden")
  }

  hideReadOnlyMode() {
    this.readOnlySectionTarget.classList.add("hidden")
  }

  showEditMode() {
    this.editSectionTarget.classList.remove("hidden")
  }

  hideEditMode() {
    this.editSectionTarget.classList.add("hidden")
  }

  storeOriginalValues() {
    if (this.hasFormTarget) {
      this.originalValues = {}
      const inputs = this.formTarget.querySelectorAll('input[type="text"], input[type="email"]')
      inputs.forEach(input => {
        this.originalValues[input.name] = input.value
      })
    }
  }

  resetForm() {
    if (this.hasFormTarget && this.originalValues) {
      const inputs = this.formTarget.querySelectorAll('input[type="text"], input[type="email"]')
      inputs.forEach(input => {
        if (this.originalValues[input.name] !== undefined) {
          input.value = this.originalValues[input.name]
        }
      })
    }
  }
}
